// extracted by css-extract-rspack-plugin
export default {"cls1":"CollapsedActivityPreview-cls1_o23","cls2":"CollapsedActivityPreview-cls2_rlA CollapsedActivityPreview-cls1_o23"};